import {INamedEntity} from 'Common/models/INamedEntity';

export function sortByName<T extends INamedEntity>(a: T, b: T) {
  return a['name'].localeCompare(b['name']);
}
